import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { useAppSelector, useAppDispatch } from '../useStore';
import { restoreAccordionStates } from '../../../store/accordionSlice';

export const useCropTrendsScrollRestore = () => {
  const { pathname } = useLocation();
  const scrollRestoredRef = useRef(false);
  const scrollYStates = useAppSelector((state) => state.scrollY);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (pathname === pageInfo.cropTrendsListPage.path && !scrollRestoredRef.current) {
      scrollRestoredRef.current = true;

      // 저장된 아코디언 상태 복원
      dispatch(restoreAccordionStates());

      // 선택한 농작물이 있으면 해당 요소로 스크롤
      if (scrollYStates.cropTrendsSelectedItem) {
        const { middleCategoryName, smallCategoryName } = scrollYStates.cropTrendsSelectedItem;

        if (smallCategoryName) {
          // 소분류가 있는 경우: 해당 아이템으로 스크롤
          const elementId = `${middleCategoryName}-${smallCategoryName}`;

          // 여러 번 시도하여 요소가 렌더링될 때까지 대기
          const attemptScroll = (attempts = 0) => {
            const element = document.getElementById(elementId);
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
            } else if (attempts < 5) {
              setTimeout(() => attemptScroll(attempts + 1), 100);
            } else {
              window.scrollTo(0, scrollYStates.cropTrendsListPageScrollY);
            }
          };

          // 아코디언이 복원된 후 스크롤 시도 (짧은 지연)
          setTimeout(() => attemptScroll(), 100);
        } else {
          // 소분류가 없는 경우: 중분류 아코디언 헤더로 스크롤
          const accordionHeaderId = `accordion-${middleCategoryName}`;

          const attemptScroll = (attempts = 0) => {
            const element = document.getElementById(accordionHeaderId);
            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
            } else if (attempts < 5) {
              setTimeout(() => attemptScroll(attempts + 1), 100);
            } else {
              window.scrollTo(0, scrollYStates.cropTrendsListPageScrollY);
            }
          };

          setTimeout(() => attemptScroll(), 100);
        }
      } else {
        // 선택한 농작물이 없으면 저장된 위치로 스크롤
        window.scrollTo(0, scrollYStates.cropTrendsListPageScrollY);
      }
    } else if (pathname !== pageInfo.cropTrendsListPage.path) {
      // 다른 페이지로 이동 시 플래그 리셋
      scrollRestoredRef.current = false;
    }
  }, [pathname, scrollYStates.cropTrendsSelectedItem, dispatch]);
};
